
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskTypeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RiskType"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskTypeBaseFragment"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"riskNameTemplate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":139}};
    doc.loc.source = {"body":"#import \"./RiskTypeBaseFragment.gql\"\n\nfragment RiskTypeFragment on RiskType {\n  ...RiskTypeBaseFragment\n  riskNameTemplate\n  description\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./RiskTypeBaseFragment.gql").definitions));


      module.exports = doc;
    
